import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Home from '@/view/home/index.vue'
import ConvertCsv from '@/view/convert-csv/index.vue'
import D2Index from '@/view/d2/index.vue'
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Home,
      meta: {
        // 页面标题title
        title: '寂洛的小窝'
      }
    },
    {
      path: '/convert-csv',
      name: 'convert-csv',
      component: ConvertCsv,
      meta: {
        title: 'convert-csv'
      }
    },
    {
      path: '/d2/*',
      name: 'd2',
      component: D2Index,
      meta: {
        title: '命运2模块'
      }
    }
  ]
})
export default router
